import { ServiceApi } from '../../utils/auth'

const state = {
    exchanges: [],
    latest:{},
    loading: false,
    error: null
}

const actions = {
    async fetchExchangeHistorial({ commit }, payload) {
        commit('exchangesBegin')
        try {
            const resp = await ServiceApi.get(`/api/exchange-rate`, payload);
            commit('exchangesSuccess', true)
            commit("SET_EXCHANGES", resp.data);
            return resp.data;
        } catch (error) {
            commit('echangesErr', error)
            return error
        }
    },
    async addExchangeRate({ commit }, payload) {
        commit('exchangesBegin')
        try {
            const resp = await ServiceApi.post(`/api/exchange-rate`, payload);
            commit('exchangesSuccess', true)
            return resp.data;
        } catch (error) {
            commit('echangesErr', error)
            return error
        }
    },
}

const getters = {
    getExchanges: state => state.exchanges,
    getLatest: state => state.latest,
    exchangesLoading: (state) => state.loading,
}

const mutations = {
    SET_EXCHANGES(state, payload) {
        state.exchanges = payload.data.rates
        state.latest = payload.data.latest
    },
    exchangesBegin(state) {
        state.loading = true
    },
    exchangesSuccess(state) {
        state.loading = false
    },
    echangesErr(state, err) {
        state.loading = false
        state.error = err
    },
}

export default {
    namespaced: false,
    state,
    actions,
    mutations,
    getters
}
